<template>
  <div class="m-15">
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
    <b-row>
      <b-col cols="12">
        <b-table
          :items="items"
          :fields="fields"
          striped
          bordered
          hover
          :current-page="currentPage"
          :per-page="perPage"
          @row-clicked="rowClicked"
        >
          <template v-slot:cell(urlfoto)="data">
            <img
              v-if="data.item.urlfoto != ''"
              width="150"
              class="center-image"
              :src="data.item.urlfoto"
              :alt="data.item.descricao"
            />
            <img
              v-else
              width="50"
              class="center-image"
              text-align="center"
              src="http://img.accesys.com.br/produtos/semFoto.png"
              alt="erro"
            />
          </template>
        </b-table>
        <nav>
          <b-pagination
            size="md"
            align="fill"
            :total-rows="getRowCount(items)"
            :per-page="perPage"
            v-model="currentPage"
            prev-text="Anterior"
            next-text="Próxima"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
    <b-modal
      centered
      ref="modal"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div slot="modal-header">
        <small>{{ codBarrasSelecionado }}</small> -
        <strong>{{ descricaoSelecionado }}</strong>
      </div>
      <template slot="modal-footer">
        <b-button @click="closeModal" variant="secondary"> Fechar </b-button>

        <b-button
          @click="newPhoto"
          variant="primary"
          :disabled="imagemSelecionado == null"
        >
          Upload
        </b-button>
      </template>
      <div v-if="mostravel">
        <picture-input
          ref="pictureInput"
          width="300"
          height="300"
          margin="16"
          accept="image/jpeg, image/png"
          size="10"
          button-class="changeBtn"
          remove-button-class="removeBtn"
          :removable="true"
          :custom-strings="{
            upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
            drag: 'Arraste uma imagem <br> (ou clique aqui)',
            change: 'Mudar foto',
            remove: 'Remover foto',
          }"
          @change="onChange"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import PictureInput from "vue-picture-input";
import axios from "axios";
import * as config from "@/config.json";
import { setTimeout } from "timers";
import InserirPromocaoVue from "../InserirPromocao.vue";

export default {
  name: "inserirpromocaoimagem",
  components: { PictureInput, Loading },
  data: () => {
    return {
      items: [],
      fields: [
        { key: "urlfoto", label: "Imagem" },
        { key: "codbarras", label: "Barras" },
        { key: "descricao", label: "Descrição" },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      mostravel: false,
      codBarrasSelecionado: null,
      descricaoSelecionado: null,
      imagemSelecionado: null,
      isLoading: false,
      error: false,
    };
  },
  methods: {
    getRowCount(items) {
      return items.length;
    },
    rowClicked(record, index) {
      console.table([record]);
      this.codBarrasSelecionado = record.codbarras;
      this.descricaoSelecionado = record.descricao;
      this.openModal();
    },
    openModal() {
      if (!this.error) {
        this.$refs.modal.show();
        setTimeout((_) => {
          this.mostravel = true;
        }, 100);
      }
    },
    closeModal() {
      this.$refs.modal.hide();
      this.mostravel = false;
    },
    onChange(image) {
      if (image) {
        this.imagemSelecionado = image;
      } else this.imagemSelecionado = null;
    },
    async newPhoto() {
      if (this.imagemSelecionado == null) {
        this.closeModal();
        this.$dialogs
          .alert("É necessário colocar uma imagem.", {
            title: "Aviso",
            size: "sm",
          })
          .then((res2) => {
            this.openModal();
          });
      } else {
        this.isLoading = true;
        this.closeModal();
        await axios
          .post(
            `${config.default.servidor}/gerencial/promocao/item/imagem`,
            {
              empresaid: localStorage.getItem("enterprise_id").toString(),
              nomeDaImagem: this.codBarrasSelecionado,
              imagem: this.imagemSelecionado,
            },
            {
              headers: {
                Authorization: "Basic c2E6QURNQUNDRVNZUw==",
              },
            }
          )
          .then((response) => {
            if (response) {
              this.items = {};
              this.carregaItems();
            }
          })
          .catch((e) => {
            alert(e);
          });
        this.isLoading = false;
      }
    },
    async carregaItems() {
      await axios
        .get(
          `${config.default.servidor}/gerencial/promocao/itens/${Number(
            localStorage.getItem("selecionado")
          )}/${localStorage.getItem("enterprise_id")}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw==",
            },
          }
        )
        .then((response) => {
          if (response) {
            this.items = response.data.data;
            this.error = response.data.error;

            if (this.error == true) {
              const options = {
                title: "Impossível continuar",
                size: "sm",
              };
              this.$dialogs.alert(
                `Necessário ativação dos itens listados para prosseguir com o cadastro da promoção.
                Verifique o cadastro dos itens no ERP!`,
                options
              );

              this.$emit("can-continue", { value: false });
            }
          } else this.items = {};
        });
    },
  },
  async beforeMount() {
    this.$emit("can-continue", { value: true });
    this.isLoading = true;
    await this.carregaItems();
    this.isLoading = false;
  },
};
</script>
<style>
</style>
